export default __webpack_public_path__ + "static/media/20251005-AZ204.29f43dd7.jpg";